import { toggle } from "./toggle";

export default toggle("doc-enabled");
